<template>
  <div class="container">
    <childPageTopImage></childPageTopImage>
    <div class="notfoundSpace">
      <p class="smallTitle">ページが見つかりません。</p>
    </div>
  </div>
</template>

<script>
import childPageTopImage from "./childPageTopImage";

export default {
  components: {
    childPageTopImage,
  },
};
</script>

<style scoped>
.container {
  width: 100%;
}

.smallTitle {
  font-size: 2.5vw;
  font-weight: 800;
  color: #072a40;
  position: relative;
}

.notfoundSpace{
    width: 100%;
    height: 20vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
</style>
